import { useEffect } from 'react';
import { useAppStore } from '@/stores/useAppStore';
import { supabase } from '@/integrations/supabase/client';

export const useWaterSync = () => {
  const { hydrationLogs } = useAppStore();
  
  useEffect(() => {
    if (!hydrationLogs || hydrationLogs.length === 0) return;
    
    const syncWaterToDatabase = async () => {
      const today = new Date().toISOString().split('T')[0];
      const todayLog = hydrationLogs.find(log => log.dateISO === today);
      
      if (todayLog) {
        const { data: { user } } = await supabase.auth.getUser();
        if (!user) return;
        
        await supabase
          .from('daily_water_logs')
          .upsert({
            user_id: user.id,
            date: today,
            amount_ml: todayLog.mlTotal
          });
      }
    };
    
    syncWaterToDatabase();
  }, [hydrationLogs]);
};
